import { render, staticRenderFns } from "./selectLaboratory.vue?vue&type=template&id=2630c5a7&scoped=true&"
import script from "./selectLaboratory.vue?vue&type=script&lang=js&"
export * from "./selectLaboratory.vue?vue&type=script&lang=js&"
import style0 from "./selectLaboratory.vue?vue&type=style&index=0&id=2630c5a7&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2630c5a7",
  null
  
)

export default component.exports